<template>
    <div class="upload-data-content">
        <div class="upload-data-content-main">
            <v-uploader v-if="!changeUploadStyle" :url="uploadUrl" form-key="lbf-file-upload" :size-limit="file_size_limit"
                :type-limit="file_type_limit" :show-error-tip="false" :show-progress="true" :data="uploadData"
                class="upload-data-content-element" :draggable="true" @complete="uploadComplete">
                <div>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M15.0555 3.52997C14.9358 3.5 14.7906 3.5 14.5 3.5C14.2094 3.5 14.0642 3.5 13.9445 3.52997C13.5866 3.61962 13.3071 3.89909 13.2175 4.25702C13.1875 4.37666 13.1875 4.52194 13.1875 4.8125V12.6875H5.3125C5.02194 12.6875 4.87666 12.6875 4.75702 12.7175C4.39909 12.8071 4.11962 13.0866 4.02997 13.4445C4 13.5642 4 13.7094 4 14C4 14.2906 4 14.4358 4.02997 14.5555C4.11962 14.9134 4.39909 15.1929 4.75702 15.2825C4.87666 15.3125 5.02194 15.3125 5.3125 15.3125H13.1875V23.1875C13.1875 23.4781 13.1875 23.6233 13.2175 23.743C13.3071 24.1009 13.5866 24.3804 13.9445 24.47C14.0642 24.5 14.2094 24.5 14.5 24.5C14.7906 24.5 14.9358 24.5 15.0555 24.47C15.4134 24.3804 15.6929 24.1009 15.7825 23.743C15.8125 23.6233 15.8125 23.4781 15.8125 23.1875V15.3125H23.6875C23.9781 15.3125 24.1233 15.3125 24.243 15.2825C24.6009 15.1929 24.8804 14.9134 24.97 14.5555C25 14.4358 25 14.2906 25 14C25 13.7094 25 13.5642 24.97 13.4445C24.8804 13.0866 24.6009 12.8071 24.243 12.7175C24.1233 12.6875 23.9781 12.6875 23.6875 12.6875H15.8125V4.8125C15.8125 4.52194 15.8125 4.37666 15.7825 4.25702C15.6929 3.89909 15.4134 3.61962 15.0555 3.52997Z"
                            fill="#A1ABC2" />
                    </svg>
                    <div :class="{ 'upload-data-content-element-text': true, 'isError': isHappenError }">
                        {{ innerDescFromPorps }}
                    </div>
                </div>
            </v-uploader>
            <v-popconfirm ref="first" :inline="true" status="warning" @confirm="handleConfirm"
                @visibleChange="handleVisibleChange">
                <div class="demo-popconfirm-first">
                    <h3>确定要删除吗？</h3>
                </div>
                <span slot="confirm-text">删除</span>
            </v-popconfirm>

            <div v-if="changeUploadStyle" class="uploadedImg"
                :style="{ backgroundImage: 'url(' + imgForUploadedUrl + ')', backgroundSize: '100% 100%' }">
                <div v-popconfirm:first class="deleteImg" />
            </div>
            <div class="upload-data-content-framedesc">
                {{ frameDesc }}
            </div>
            <div v-if="isNoUploadBeforeSubmit && uploadId !== 6" class="upload-data-content-framedesc isError">
                {{ tipsAfterSumbit }}
            </div>
            <!-- <div class="upload-data-content-limitdesc">{{limitDesc}}</div> -->
        </div>
    </div>
</template>

<script>
// import Uploader from '@/components/uploader/index'
import { cookie } from '@tencent/qd-lib';
export default {
    props: {
        // 文件上传URL
        uploadUrl: {
            type: String,
            default: '',
        },
        // 文件上传框中间的文字
        innerDesc: {
            type: String,
            default: '点击选择或拖动文件到此区域',
        },
        // 文件上传框上传文件的格式描述
        // limitDesc: {
        //     type: String,
        //     default: '2M以内，支持png、jpg、jpeg格式'
        // },
        // 文件上传框底部描述
        frameDesc: {
            type: String,
            default: '',
        },
        // 文件上传的规定大小
        file_size_limit: {
            type: String,
            default: '2MB',
        },
        // 文件上传的规定格式
        file_type_limit: {
            type: String,
            default: '*.png;*.jpg;*.jpeg',
        },
        // 当前上传文件框的id
        uploadId: {
            type: Number,
            default: 0,
        },
        // 没有上传的文件框数组
        uploadArr: {
            type: Object,
            default: () => { },
        },
        // 是否点击过提交按钮
        isClickSubmit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // 用来切换到上传完文件之后的元素
            changeUploadStyle: false,
            // 上传完文件之后的元素背景图片
            imgForUploadedUrl: '',
            // 文件上传之后是否因为格式、打小等问题产生错误
            isHappenError: false,
            // 文件上传之后的文字提示
            innerDescFromPorps: '',
            // 点击提交之后的文字提示
            tipsAfterSumbit: '不能为空',
            // 其他需要传给后端的参数
            uploadData: {
                _bqq_csrf: cookie.get('_bqq_csrf') || null,
            },
        };
    },
    computed: {
        // 当前的这个组件在点击提交之后是否没有上传文件
        isNoUploadBeforeSubmit() {
            for (const index in this.uploadArr) {
                if (!this.isClickSubmit) {
                    return false;
                }
                if (index == this.uploadId && Object.keys(this.uploadArr[index]).length !== 0) {
                    return false;
                }
            }
            return true;
        },
    },
    mounted() {
        this.innerDescFromPorps = this.innerDesc;
    },
    methods: {
        /**
         * 上传完文件之后的执行函数
         * @param {object} res 文件详情信息
         * @return {void}
         */
        uploadComplete(res) {
            // 如果结果正确，当前没有发生错误
            if (res.status !== 0) {
                if (res.data.type === 'TYPE') {
                    this.isHappenError = true;
                    this.innerDescFromPorps = '图片格式不支持';
                    return;
                }
                if (res.data.type === 'SIZE') {
                    this.isHappenError = true;
                    this.innerDescFromPorps = '图片大小不能超过2M';
                    return;
                }
            }
            if (res.data.data.code === 0) {
                this.isHappenError = false;
                this.innerDescFromPorps = this.innerDesc;
                this.changeUploadStyle = true;
                this.imgForUploadedUrl = res.data.data.data.url || '';
                this.$parent.changeUploadArr(this.uploadId, res.data.data.data.url);
            } else {
                this.isHappenError = true;
                if (res.data.data.message) {
                    this.innerDescFromPorps = res.data.data.message;
                    return;
                }

                this.innerDescFromPorps = '图片上传失败';
                return;
            }
        },

        /**
         * 删除弹框的确认按钮事件
         * @return {void}
         */
        handleConfirm() {
            this.deleteIconLight = true;
            this.changeUploadStyle = false;
            this.imgForUploadedUrl = '';
            this.$parent.changeUploadArr(this.uploadId, {});
        },

        /**
         * 删除弹框的取消按钮事件，用的vhtml，好像是需要必须写个函数
         * @return {void}
         */
        handleVisibleChange(res) {
            this.$parent.stopScrollControl(res);
        },
    },
};
</script>

<style lang="less" scoped>
.upload-data-content {
    display: inline-block;
    padding-right: 50px;
    text-align: left;
    &-main {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    &-element {
        &-text {
            font-size: 11px;
            color: #A8ABB3;
            line-height: 15px;
            font-style: normal;
            text-align: center;
            padding: 0 6px;
        }

        /deep/ .v-uploader-dnd {
            max-width: 100px;
            max-height: 100px;
            min-width: 100px;
            min-height: 100px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #a8abb3;
            font-size: 11px;
            border: 1px dashed #E1E6F0;
            box-sizing: border-box;
            border-radius: 3px;

            &:hover {
                .v-icon {
                    color: #84868c;
                }
            }
        }

        /deep/ .v-uploader__list {
            display: none;
        }
    }

    &-framedesc {
        padding-top: 8px;
        font-size: 12px;
        line-height: 17px;
        white-space: nowrap;
        color: rgba(1, 11, 50, 0.41);
    }

    &-limitdesc {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        color: #A8ABB3;
    }
}

.uploadedImg {
    position: relative;
    width: 100px;
    height: 100px;
}

.deleteImg {
    background-image: url(../assets/deletesimple.png);
    background-size: cover;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    margin-top: -12px;
    left: 50%;
    z-index: 10;
    margin-left: -12px;
}

.deleteImg:hover {
    background-image: url(../assets/deletelight.png);
    background-size: cover;
    cursor: pointer;
}

.isError {
    color: #FF4222;
}
</style>
